import classNames from 'classnames';
import {ComponentProps, FC} from 'react';
import styles from './MeinMarkup.module.css';

interface IProps extends ComponentProps<'div'> {
    html: string;
    className?: string;
}

export const MeinMarkup: FC<IProps> = ({html, className, ...rest}) => {
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: html,
            }}
            className={classNames(styles.markup, className)}
            {...rest}
        />
    );
};
